import { getCommercialBuildingClass } from './getCommercialBuildingClass';
import { getCommercialFloorLabel } from './getCommercialFloorLabel';
import { getCommercialTotalArea } from './getCommercialTotalArea';
import { getCommercialTypeTitle } from './getCommercialTypeTitle';
import { isCoworking } from './isCoworking';
import { IOffer } from '../../../types/offer';

export function getCommercialHeading4Parts(offer: IOffer): string[] {
  return [
    getCommercialTypeTitle(offer) || undefined,
    isCoworking(offer) ? undefined : getCommercialTotalArea(offer),
    getCommercialFloorLabel(offer),
    getCommercialBuildingClass(offer),
  ].filter((part): part is string => Boolean(part));
}
